/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ForgetQr_user = {
    readonly id: string;
    readonly name: string;
    readonly needsNewPin: boolean;
    readonly primaryWallet: {
        readonly name: string;
    } | null;
    readonly " $refType": "ForgetQr_user";
};
export type ForgetQr_user$data = ForgetQr_user;
export type ForgetQr_user$key = {
    readonly " $data"?: ForgetQr_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ForgetQr_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForgetQr_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsNewPin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "primaryWallet",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = '1d231488eaf82e374495364df4d63ba9';
export default node;
